import { IFormationLayout, SoccerPlayerPosition } from "../../../types";

export const generateFormationLayout = (formation: string) => {
  if (!formation || formation.trim() === "") return [];

  const layout: IFormationLayout[] = [];
  const rows = formation.split("-");
  const isFiveOrMoreLayeredFormation = rows.length >= 5;
  const verticalSpacing = isFiveOrMoreLayeredFormation ? 1.15 : 1.5;
  const totalRows = rows.length + 1; // including goalkeeper

  const bufferSpace = totalRows > 4 ? 0 : 0.5;

  // Compute y positions from bottom (goalkeeper) up
  const startY = (totalRows - 1) * verticalSpacing + bufferSpace;

  // Goalkeeper at the bottom
  layout.push({
    i: "Goalkeeper",
    x: 4,
    y: startY,
    w: 2,
    h: 1,
  });

  // Add players row by row, stacking upward
  rows.forEach((count, rowIndex) => {
    const playerCount = parseInt(count, 10);
    if (!playerCount) return;

    const y = startY - (rowIndex + 1) * verticalSpacing; // y goes up
    const startX = Math.floor((10 - playerCount * 2) / 2); // center alignment

    const positionKey =
      rowIndex === 0
        ? "Defender"
        : rowIndex === 1
        ? "Midfielder"
        : rowIndex === rows.length - 1
        ? "Striker"
        : "Attacker";

    for (let i = 0; i < playerCount; i++) {
      layout.push({
        i: `${positionKey}-${rowIndex}-${i}`,
        x: startX + i * 2,
        y,
        w: 2,
        h: 1,
      });
    }
  });

  return layout;
};

export interface IPlayers {
  name: string;
  jerseyNumber: number;
  position: SoccerPlayerPosition;
  isCaptain?: boolean;
  id: string;
}

export const getPlayerByPosition = (
  players: IPlayers[],
  position: SoccerPlayerPosition,
  index: number
) => {
  const playersInPosition = players.filter((p) => p.position === position);
  return playersInPosition[index] || null;
};
